import { Dialog } from '@base-ui/react/dialog'
import { Menu, X } from 'lucide-react'
import Sidebar from './Sidebar'

// Only navigation belongs to this Dialog context; business dialogs are siblings.
export default function MobileNavigation({ open, onOpenChange }: {
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  return <Dialog.Root open={open} onOpenChange={onOpenChange}>
    <Dialog.Trigger aria-label="開啟導覽" className="flex size-9 items-center justify-center rounded-lg text-muted-foreground hover:bg-muted focus-visible:outline-2 focus-visible:outline-primary">
      <Menu className="size-4" aria-hidden="true" />
    </Dialog.Trigger>
    <Dialog.Portal>
      <Dialog.Backdrop className="fixed inset-0 z-40 bg-slate-950/35" />
      <Dialog.Popup className="fixed inset-y-0 left-0 z-50 w-64 bg-white outline-none">
        <Dialog.Title className="sr-only">商戶導覽選單</Dialog.Title>
        <Dialog.Close aria-label="關閉導覽" className="absolute right-2 top-5 flex size-6 items-center justify-center rounded bg-white text-muted-foreground hover:bg-muted">
          <X className="size-4" aria-hidden="true" />
        </Dialog.Close>
        <Sidebar collapsed={false} onNavigate={() => onOpenChange(false)} />
      </Dialog.Popup>
    </Dialog.Portal>
  </Dialog.Root>
}
